import { Component, OnInit, ViewChild } from '@angular/core';
import { ControllerService } from '../shared/services/controller.service';
import { HttpService } from '../shared/services/http.service';

@Component({
    selector: 'app-fullname',
    templateUrl: './fullname.component.html',
    styleUrls: ['./fullname.component.scss'],
    standalone: false
})
export class FullnameComponent implements OnInit {


  @ViewChild("name", { static: false }) name;

  constructor(public controller: ControllerService, private httpService: HttpService) { }

  prompt = 'Please enter your full name'
  error = 'Your name is required'
  paragraph = ''

  helper = ''
  invalid = false

  timeout: any
  onType( event ){

    if( this.timeout ){
      clearTimeout( this.timeout )
    }
    this.timeout = window.setTimeout( () => {
      if( event.target.value && event.target.value.length > 0 ){
        this.invalid = false
      }else{
        this.invalid = true
      }
    }, 250)
  }

  ngOnInit() {

    const elements = this.controller.getSectionComponents()[0].elements
    this.prompt = elements.find( ({type}) => type == 'header').value
    this.helper = elements.find( ({type}) => type == 'helper').value

    const p = elements.find( ({type}) => type == 'p')

    this.paragraph = p && p.value
  }

  async next(){
    const name = this.name.nativeElement.value

    this.invalid = false

    if( !name || !name.length ){
      this.invalid = true

      return
    }

    const r: any = await this.httpService.postAsync('user/name', {name})

    if( !r.success ){
      // now what?
      this.invalid = true
      return
    }
    await this.controller.next()

  }


}
